import { render, staticRenderFns } from "./TraineeReg.vue?vue&type=template&id=1b8e7a07&scoped=true"
import script from "./TraineeReg.vue?vue&type=script&lang=js"
export * from "./TraineeReg.vue?vue&type=script&lang=js"
import style0 from "./TraineeReg.vue?vue&type=style&index=0&id=1b8e7a07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e7a07",
  null
  
)

export default component.exports